import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthentificationLogin from './views/authentification-login.vue'
import CustomerDashboard from './views/customer-dashboard.vue'
import Sandbox from './views/Sandbox.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: AuthentificationLogin
  },
  {
    path: '/authentification-login',
    component: AuthentificationLogin
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  },
  {
    path: '/customer-dashboard',
    component: CustomerDashboard
  },
  {
    path: '/sandbox',
    component: Sandbox
  }
]
const router = new VueRouter({
  routes
})

export default router
